import api from './api.js';

class ReviewService {
  async getReviews() {
    try {
      const response = await api.get('/reviews/');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des avis:', error);
      // Retourner des données par défaut en cas d'erreur
      return this.getDefaultReviews();
    }
  }

  async createReview(reviewData) {
    try {
      const response = await api.post('/reviews/', reviewData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création de l\'avis:', error);
      throw error;
    }
  }

  async updateReview(reviewId, reviewData) {
    try {
      const response = await api.put(`/reviews/${reviewId}/`, reviewData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de l\'avis:', error);
      throw error;
    }
  }

  async deleteReview(reviewId) {
    try {
      await api.delete(`/reviews/${reviewId}/`);
      return true;
    } catch (error) {
      console.error('Erreur lors de la suppression de l\'avis:', error);
      throw error;
    }
  }

  async likeReview(reviewId) {
    try {
      const response = await api.post(`/reviews/${reviewId}/like/`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors du like de l\'avis:', error);
      throw error;
    }
  }

  async getReviewStats() {
    try {
      const response = await api.get('/reviews/stats/');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des statistiques:', error);
      // Retourner des statistiques par défaut
      return this.getDefaultStats();
    }
  }

  getDefaultReviews() {
    return [
      {
        id: 1,
        author: 'Marie Dubois',
        avatar: 'MD',
        rating: 5,
        date: 'Il y a 2 jours',
        verified: true,
        model: 'iPhone 15 Pro Max',
        title: 'Exceptionnel !',
        content: 'Je suis passée de l\'iPhone 13 au 15 Pro Max et la différence est incroyable. La caméra pro est absolument fantastique, les photos en basse lumière sont d\'une qualité professionnelle. Le design en titane est très élégant et beaucoup plus léger que je ne le pensais. L\'autonomie est excellente, je tiens facilement deux jours avec une charge.',
        helpful: 234,
        images: ['review1-1', 'review1-2'],
        response: {
          author: 'Équipe INZA STORE',
          date: 'Il y a 1 jour',
          content: 'Merci beaucoup pour votre avis détaillé Marie ! Nous sommes ravis que vous soyez si satisfaite de votre nouvel iPhone 15 Pro Max. N\'hésitez pas si vous avez des questions sur l\'utilisation de votre appareil !'
        }
      },
      {
        id: 2,
        author: 'Thomas Martin',
        avatar: 'TM',
        rating: 5,
        date: 'Il y a 1 semaine',
        verified: true,
        model: 'iPhone 15 Pro',
        title: 'Le meilleur smartphone du marché',
        content: 'En tant que développeur, la performance de la puce A17 Pro est impressionnante. Mes applications s\'exécutent sans aucun lag et le compilateur fonctionne à merveille. L\'écran ProMotion rend tout plus fluide et les couleurs sont incroyables. Le passage à l\'USB-C est enfin arrivé !',
        helpful: 156,
        images: [],
        response: null
      },
      {
        id: 3,
        author: 'Sophie Laurent',
        avatar: 'SL',
        rating: 4,
        date: 'Il y a 2 semaines',
        verified: true,
        model: 'iPhone 15',
        title: 'Très bon smartphone mais...',
        content: 'L\'iPhone 15 est excellent, Dynamic Island est vraiment pratique et la caméra 48MP fait de belles photos. Seul regret : pas de ProMotion sur ce modèle. Pour le prix, j\'aurais aimé avoir un écran 120Hz. Sinon, c\'est un téléphone formidable pour un usage quotidien.',
        helpful: 89,
        images: ['review3-1'],
        response: null
      },
      {
        id: 4,
        author: 'Lucas Petit',
        avatar: 'LP',
        rating: 5,
        date: 'Il y a 3 semaines',
        verified: true,
        model: 'iPhone 15 Plus',
        title: 'Parfait pour le multimédia',
        content: 'Le grand écran de 6.7 pouces est idéal pour regarder des vidéos et jouer. L\'autonomie est exceptionnelle, je peux utiliser mon téléphone toute la journée sans m\'inquiéter de la batterie. La qualité de fabrication est excellente comme toujours avec Apple.',
        helpful: 67,
        images: [],
        response: null
      },
      {
        id: 5,
        author: 'Emma Rousseau',
        avatar: 'ER',
        rating: 5,
        date: 'Il y a 1 mois',
        verified: true,
        model: 'iPhone 15 Pro Max',
        title: 'Investissement qui vaut le coup',
        content: 'Oui c\'est cher, mais la qualité justifie le prix. Je viens de Samsung et l\'écosystème Apple est vraiment bien pensé. Tout fonctionne parfaitement ensemble. Le téléobjectif 5x est génial pour les concerts et les événements sportifs.',
        helpful: 145,
        images: ['review5-1', 'review5-2', 'review5-3'],
        response: {
          author: 'Équipe INZA STORE',
          date: 'Il y a 3 semaines',
          content: 'Bonjour Emma, merci pour votre retour ! Nous sommes contents que votre transition vers l\'écosystème Apple se passe bien. N\'hésitez pas à découvrir nos tutoriels pour optimiser votre expérience !'
        }
      }
    ];
  }

  getDefaultStats() {
    return {
      total_reviews: 1247,
      average_rating: 4.8,
      rating_distribution: {
        5: 892,
        4: 245,
        3: 89,
        2: 15,
        1: 6
      },
      model_distribution: {
        'iPhone 15 Pro Max': 423,
        'iPhone 15 Pro': 389,
        'iPhone 15 Plus': 234,
        'iPhone 15': 201
      }
    };
  }
}

const reviewService = new ReviewService();
export default reviewService;
